import { render, staticRenderFns } from "./LastImportedIncidentsViewResolver.vue?vue&type=template&id=6bd9b3eb&"
import script from "./LastImportedIncidentsViewResolver.vue?vue&type=script&lang=js&"
export * from "./LastImportedIncidentsViewResolver.vue?vue&type=script&lang=js&"
import style0 from "./LastImportedIncidentsViewResolver.vue?vue&type=style&index=0&id=6bd9b3eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports